module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Ballers-S1.8249a5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Ballers-S1.jpg
// module id = uHSO
// module chunks = 0